import { Grid } from "@mui/material"

interface IOrgInfoActivitiesWrapper {
    children: React.ReactNode;
}

export const OrgInfoActivitiesWrapper: React.FunctionComponent<IOrgInfoActivitiesWrapper> = ({
    children
}) => {
    return (
        <Grid item width="100%" border="1px solid #0000001A" borderRadius="10px" padding="20px" height="100%">
            { children }
        </Grid>
    )
}